<template>
  <recycle-scroller
    class="c-led-list"
    v-if="list.length"
    :items="list"
    :item-size="200"
    @scroll.native.passive="onScroll"
  >
    <template v-slot="{ item }">
      <LEDListItem :source="item" :onLiked="onLiked" :onDeleted="onDeleted" />
    </template>
    <div slot="after" v-show="count > list.length" class="loading-spinner">
      <md-progress-spinner md-mode="indeterminate" :md-diameter="25" />
    </div>
  </recycle-scroller>
</template>
<script>
import LEDListItem from "./LEDListItem.vue";

export default {
  name: "CLedList",
  components: {
    LEDListItem,
  },
  props: {
    query: Object,
    isLiked: Boolean,
    isDraft: Boolean,
  },
  data() {
    return {
      loading: false,
      pageSize: 10,
      page: 0,
      list: [],
      count: 0,
    };
  },
  methods: {
    getDataKey(data) {
      return data.uuid + new Date().getTime();
    },
    getList(page = 1) {
      this.loading = true;
      let type = "led/getLEDList";
      if (this.isLiked) {
        type = "led/getLEDLikeList";
      } else if (this.isDraft) {
        type = "led/getLEDDraftList";
      }
      this.$store
        .dispatch(type, {
          ...this.query,
          page_number: page,
          page_size: this.pageSize,
        })
        .then((res) => {
          res.results = res.results || [];
          this.list = page === 1 ? res.results : this.list.concat(res.results);
          this.page = page;
          this.count = res.results.length === 0 ? this.list.length : res.count;
          this.$emit("change", {
            list: this.list,
            count: this.count,
            page: this.page,
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          setTimeout(() => {
            this.onScrollToBottom();
          }, 1000);
        });
    },
    onScrollToBottom() {
      const { loading, list, count } = this;
      if (!loading && count !== list.length) {
        this.getList(this.page + 1);
      }
    },
    onScroll(e) {
      const { target } = e;
      const currentScroll = target.scrollTop;
      const scrollableDistance = Math.max(
        0,
        target.scrollHeight - target.offsetHeight
      );
      if (currentScroll >= scrollableDistance - 400) {
        this.onScrollToBottom();
      }
    },
    onLiked() {
      // this.getList();
      this.$emit("liked");
    },
    onDeleted() {
      this.getList();
      this.$emit("deleted");
    },
  },
  watch: {
    query(newQuery, oldQuery) {
      if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
        this.getList();
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.c-led-list {
  overflow-y: auto;

  .item {
    padding: 50px 0;
    margin: 0 auto;
  }

  .loading-spinner {
    padding: 50px 0;
    text-align: center;
  }
}
</style>
